<template>
  	<div class="bookinf-form">
		<v-container>
            V2
			<v-row>
				<v-col cols="4">
					<v-date-picker 
						v-model = 'form.date'
        				:allowed-dates="allowedDates"
					></v-date-picker>
				</v-col>
				<v-col cols="8">
					<h3> {{ experimentName }} </h3>
					<v-text-field
						v-model = 'form.school'
						label = 'School'
						required
					></v-text-field>
					<v-text-field
						v-model = 'form.person'
						label = 'Contact Person'
						required
					></v-text-field>
					<v-text-field
						v-model = 'form.phone'
						label = 'Phone Number'
						required
					></v-text-field>
					<v-text-field
						v-model = 'form.email'
						label = 'Email'
						required
						placeholder = 'For Recieving Confirmation Email.'
					></v-text-field>
					<p>By clicking submit you agree to the <span class='blue--text' @click= 'dialog = true' >Terms and Conditions</span>.</p>
					<v-btn class='float-right' @click='submit'>Submit</v-btn>
				</v-col>
			</v-row>
		</v-container>
		<v-dialog v-model = 'dialog' persistent>
		<v-card>
			<v-card-title class="headline">Terms and Conditions</v-card-title>
			<v-card-text>
				<div class="modal-body">
					<h4>Borrowing / Returning</h4>
					<ol>
						<li>Date in green is available for booking. </li>
						<li>Date in light grey is not available for booking.</li>
						<li>School may borrow equipment of one experiment each time.</li>
						<li>Equipment set can be checked out for 2 weeks from Monday to next Friday.</li>
						<li>Equipment set is available on a first-come, first-served basis. </li>
						<li>Confirmation / Rejection Letter will be sent after the approval / disapproval of project team. </li>
						<li>Borrowers should inform project team the code of equipment that is not in good condition through email immediately.</li>
					</ol>

					<hr>
					<h4>Terms</h4>
					<ol>
						<li>Equipment sets must remain in use according to teachers’ instruction.  </li>
						<li>All overdue items will be charged at the penalties of $20/item/working day.</li>
						<li>Borrowers are responsible for the loss, theft or damage of the equipment set.</li>
						<li>Borrowers must pay the full replacement costs and processing costs.</li>
						<li>All matters and disputes are subject to the final decision of project team.</li>
					</ol>
					<p>For inquiries, please contact Miss Kathy Wong via <a href="mailto:klaiwong@polyu.edu.hk" target="_top">klaiwong@polyu.edu.hk</a></p>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="green darken-1" text @click="dialog = false">Agree</v-btn>
			</v-card-actions>
		</v-card>
		</v-dialog>
  	</div>
</template>

<script>
	import moment from 'moment';
    import firebase from 'firebase'
    import db from '../firestore'
  	export default {
    name: 'BookingForm',

    data: () => ({
		form:{
			school: '',
			person: '',
			phone: '',
			email: '',
			availableDates: [],
			date: ''
		},
		dialog: false,
		dates : [
		]
    }),
  	computed: {
		experimentName: function(){
			var self = this;
			let name = '';
			switch (self.$route.params.experiment_id) {
			case 'gas_law':
				name = "Gas Law";
				break;
			case 'gas_law_200':
				name = "Gas Law (200)";
				break;
			case 'em':
				name = "Electromagnetism & Ohm's Law";
				break;
			case 'env':
				name = "Environmental Monitoring & Plant Growth";
				break;
			case 'acc':
				name = "Accelerometer for gravitational acceleration, circular motion & simple harmonic motion";
				break;
			}
			return name;
		}
	},
	mounted(){
		var self = this;
		self.getSlots();
	},
	methods:{
		getSlots: function(){
            var self = this;
			self.slots = [];
			db.collection("slots")
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
					if(doc.data().experiment_id == self.$route.params.experiment_id){
                        if(doc.data().assign_to == '' || doc.data().assign_to == null){
    						self.dates.push(doc.data().date);
                        }
                    }
                });
            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });
		},
	    allowedDates: function(val){
			var self = this;
			return self.dates.indexOf(val) !== -1;
		},
		submit: function(){
			var self = this;
			if(self.form.school == ""){
				alert('Please Enter School Name');
				return;
			}
			if(self.form.person == ""){
				alert('Please Enter Contact Person');
				return;
			}
			if(self.form.email == ""){
				alert('Please Enter Email');
				return;
			}
			if(self.form.phone == ""){
				alert('Please Enter Phone Number');
				return;
			}
			if(self.form.date == ""){
				alert('Please Select Booking Date');
				return;
            }
            
            
            db.collection("applications")
            .add({ 
                person: self.form.person,
                school: self.form.school,
                phone: self.form.phone,
                email: self.form.email,
                experiment: self.$route.params.experiment_id,
                selected_date: self.form.date,
                applied_at: Date.now()
            })
            .then(() => {
                

                const url = 'https://hooks.slack.com/services/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'
                const data = {
                    "text": "New Booking from \n"
                            + self.form.person + "\n"
                            + self.form.school + "\n"
                            + self.form.phone + "\n"
                            + self.form.email + "\n"
                            + self.$route.params.experiment_id + "\n"
                            + self.form.date + "\n"
                            + "https://stem-ap.polyu.edu.hk/lyp/booking/#/application" + "\n"
                            + "https://stem-ap.polyu.edu.hk/lyp/booking/#/slot" + "\n"
                            
                }
                self.axios.post(url, JSON.stringify(data), {
                withCredentials: false,
                transformRequest: [(data, headers) => {
                    delete headers.post["Content-Type"]
                    return data
                }]
                })
                alert("Submit Success");
            })
            .catch((error) => {
                console.error("Error writing document: ", error);
                alert('Error: Please Try again / Give us an email for application');
            });

		}
	}
}
</script>
